import { render, staticRenderFns } from "./PracticeExamHistory.vue?vue&type=template&id=1a3265b8&scoped=true"
import script from "./PracticeExamHistory.vue?vue&type=script&lang=js"
export * from "./PracticeExamHistory.vue?vue&type=script&lang=js"
import style0 from "./PracticeExamHistory.vue?vue&type=style&index=0&id=1a3265b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3265b8",
  null
  
)

export default component.exports